import React, { useMemo, useState } from "react"
import { Row, Col, Card, CardBody, Table, CardTitle } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagi2 from "common/utils/Pagi2"
import { CommonTableContainer } from "common/utils/ComonTableContainer"
import moment from "moment"

const projectStatus = [
  { label: "Not Started", value: "0" },
  { label: "In Progress", value: "1" },
  { label: "On Hold", value: "2" },
  { label: "Cancelled", value: "3" },
  { label: "Finished", value: "4" },
];

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between">
        <Col md={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div>
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonTableContainer
        columns={columns}
        data={data}
        status={true}
      />

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagi2
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const ViewProject = ({ customer_project }) => {
  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "project_id",
        isInfoIcon: false,
        className: "project_id text-center",
        Cell: cellprops => {
          return (
            <div className="text-center">
              {cellprops.row.original?.id}
            </div>
          )
        }
      },
      {
        Header: "Project Name",
        accessor: "project_name",
        isInfoIcon: false,
        className: "project_name",
        Cell: cellprops => {
          return (
            <div className="">
              {cellprops.row.original?.project_name || "-"}
            </div>
          )
        }
      },
      {
        Header: "Customer",
        accessor: "project_customer",
        isInfoIcon: false,
        className: "project_customer",
        Cell: cellprops => {
          return (
            <div className="text-centers">
              {cellprops.row.original?.customerDetails?.company || "-"}
            </div>
          )
        }
      },
      {
        Header: "State Date",
        accessor: "project_start",
        isInfoIcon: false,
        className: "project_start",
        Cell: cellprops => {
          return (
            <div className="">
              {moment(cellprops.row.original?.startdate.slice(0, 10)).format("DD-MM-YYYY")}
            </div>
          )
        }
      },
      {
        Header: "Due Date",
        accessor: "project_due",
        isInfoIcon: false,
        className: "project_due",
        Cell: cellprops => {
          return (
            <div className="">
              {cellprops.row.original?.enddate ? moment(cellprops.row.original?.enddate.slice(0, 10)).format("DD-MM-YYYY") : "-"}

            </div>
          )
        }
      },
      {
        Header: "Status",
        accessor: "project_status",
        isInfoIcon: false,
        className: "project_status",
        Cell: (cellProps) => {
          const Status = projectStatus?.filter(
            (item) => item.value === cellProps.row.original.status
          );
          return <div className="">{Status[0].label || "--"}</div>;
        },
      },
      // {
      //   Header: "DID",
      //   accessor: "project_did",
      //   isInfoIcon: false,
      //   className: "project_did",
      //   Cell: cellProps => {
      //     const startDate = moment()
      //     const deliveryDateBefore = moment(
      //       cellProps.row.original.deliverydatebefore
      //     )
      //     const differenceInDays = deliveryDateBefore?.diff(startDate, "days")
      //     return <>{differenceInDays ? differenceInDays : ""}</>
      //   },
      // },
      // {
      //   Header: "Action",
      //   accessor: "pro_action",
      //   isInfoIcon: false,
      //   className: "pro_action",
      //   Cell: cellprops => {
      //     return (
      //       <a className="btn btn-sm btn-outline-secondary me-1" title="View">
      //         <i className="fas fa-eye" ></i>
      //       </a>
      //     )
      //   }
      // },
    ],
    []
  )

  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 text-dark">Projects</CardTitle>

                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={customer_project}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewProject
